import { Box } from '@mui/material';
import type { PageProps } from 'gatsby';
import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

import HeaderArc from '@components/DrilldownHeader/HeaderArc';
import MainTitle from '@components/MainTitle';
import { Spacer } from '@components/MainTitle/MainTitle.style';

import { useFontSize } from '@hooks/useFontSize';
import { useIsMobile } from '@hooks/useIsMobile';

import AppLayout from '@layouts/AppLayout';
import { BigTitle, BigTitleWrapper } from '@layouts/Layouts/BigTitleLayout';

import Main from '@views/Records/Routines/Main';

const messages = defineMessages({
  title: {
    id: 'routinesMain.title',
    defaultMessage: 'Routines',
  },
});

export default function RoutinesPage({ params }: PageProps) {
  const { formatMessage } = useIntl();
  const titleFontSize = useFontSize(72);
  const mobile = useIsMobile();

  return (
    <AppLayout friendlyName={formatMessage(messages.title)} limitHeight>
      <Box>
        {mobile ? (
          <>
            <MainTitle title={formatMessage(messages.title)} />
            <Spacer />
          </>
        ) : (
          <>
            <BigTitleWrapper>
              <BigTitle fontSize={titleFontSize}>
                {formatMessage(messages.title)}
              </BigTitle>
            </BigTitleWrapper>
            <HeaderArc />
          </>
        )}
      </Box>
      <Main {...params} />
    </AppLayout>
  );
}
